import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { EditSchoolSettings } from '../EditSchoolSettings/EditSchoolSettings';
import { SchoolSettingsAdvanced } from '../../SchoolSettingsAdvanced/SchoolSettingsAdvanced';
import { GmEmailSettings } from '../../GmEmailSettings/GmEmailSettings';
import { Subscriptions } from '../../Subscriptions/Subscriptions';
import { PaymentsAccounts } from '../../PaymentsAccounts/PaymentsAccounts';
import { PublicSiteSettings } from '../PublicSiteSettings/PublicSiteSettings';
import { BigScreenSettings } from '../BigScreenSettings/BigScreenSettings';
import { WebsiteWidgets } from '../WebsiteWidgets/WebsiteWidgets';
import { EventCommunicationsSettings } from '../EventCommunicationsSettings/EventCommunicationsSettings';
import { AvailabilitySettings } from '../AvailabilitySettings/AvailabilitySettings';
import '../SchoolSettings.scss';

export const SchoolSettingsRouting = allProps => {
  return (
    <Switch>
      <Route
        exact
        path={'/school/settings/base'}
        render={props => (
          <EditSchoolSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />
        )}
      />
      <Route exact path={'/school/settings/base/edit'} render={() => <Redirect to="/school/settings/base" />} />
      <Route
        exact
        path={'/school/settings/public-site'}
        render={props => (
          <PublicSiteSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />
        )}
      />
      <Route
        exact
        path={'/school/settings/big-screen'}
        render={props => (
          <BigScreenSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />
        )}
      />
      <Route exact path={'/school/settings/website-widgets'} render={() => <WebsiteWidgets user={allProps.user} />} />
      <Route exact path={'/school/settings/event-communications'} render={() => <EventCommunicationsSettings user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />} />
      <Route exact path={'/school/settings/availability'} render={() => <AvailabilitySettings user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />} />
      <Route
        exact
        path={'/school/settings/advanced'}
        render={props => (
          <SchoolSettingsAdvanced {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />
        )}
      />
      <Route
        exact
        path={'/school/settings/subscriptions'}
        render={props => <Subscriptions {...props} user={allProps.user} />}
      />
      <Route
        exact
        path={'/school/settings/payment-accounts'}
        render={props => <PaymentsAccounts {...props} user={allProps.user} />}
      />
      <Route exact path={'/school/settings'} render={() => <Redirect to="/school/settings/base" />} />
      <Route
        exact
        path={'/school/settings/gm-email'}
        render={props => <GmEmailSettings {...props} user={allProps.user} onSchoolUpdate={allProps.onSchoolUpdate} />}
      />
    </Switch>
  );
};

SchoolSettingsRouting.displayName = 'SchoolSettingsRouting';
